import { forwardRef } from "react";
import { Menu as MuiMenu, MenuProps } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { mergeWith } from "lodash";

import { colors } from "theme";

const useStyles = makeStyles(() => ({
  paper: {
    width: (props: any) => props.paperWidth,
    background: "white",
    borderRadius: 0,
    boxShadow:
      "0px 16px 24px rgba(0, 0, 0, 0.14), 0px 6px 30px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.2);",
  },
  list: {
    padding: 0,
    "& .MuiDivider-root": {
      backgroundColor: colors.ocean[600],
    },
  },
}));

const Menu = forwardRef(
  (
    {
      classes = {},
      paperWidth = 218,
      ...otherProps
    }: MenuProps & { paperWidth?: number },
    ref: any
  ) => {
    const baseClasses = { ...useStyles({ paperWidth }) };
    const menuClasses = mergeWith(
      baseClasses,
      classes,
      (class1: string, class2: string) => `${class1} ${class2}`
    );

    return (
      <MuiMenu
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        keepMounted
        elevation={0}
        ref={ref}
        {...otherProps}
        classes={menuClasses}
        TransitionProps={{
          onEntered: () => {
            document.body.style.paddingRight = "15px";
            document.body.style.overflow = "hidden";
          },
        }}
        onClose={(evt: any) => {
          document.body.removeAttribute("style");
          if (otherProps.onClose) {
            otherProps.onClose(evt, "backdropClick");
          }
        }}
      />
    );
  }
);

export default Menu;
